import axios from 'axios';

export default {
  async getProductList(context, { sort, payload }) {
    try {
      const { data } = await axios.post(
        `${process.env.API_BASE_URL}/products/health/tpd${sort ? `?sort=${sort}` : ''}`,
        payload
      );
      const response = data;
      context.commit('setListProduct', response.data);
    } catch (error) {
      return error;
    }
  },
  async getListClaim(context) {
    try {
      const query = `orderBy=updatedAt&&limit=100`;
      const { data } = await this.$axios.get(`/health/claim?${query}`);
      const response = data;
      context.commit('updateClaims', response);
    } catch (error) {
      throw error;
    }
  }
};
